__turbopack_context__.v({
  "alignCenter": "Overviewbox-module-scss-module__7Pkbmq__alignCenter",
  "animatedLine": "Overviewbox-module-scss-module__7Pkbmq__animatedLine",
  "bgwhite": "Overviewbox-module-scss-module__7Pkbmq__bgwhite",
  "growLine": "Overviewbox-module-scss-module__7Pkbmq__growLine",
  "hover03": "Overviewbox-module-scss-module__7Pkbmq__hover03",
  "imagecontainer": "Overviewbox-module-scss-module__7Pkbmq__imagecontainer",
  "inner": "Overviewbox-module-scss-module__7Pkbmq__inner",
  "innerPadding": "Overviewbox-module-scss-module__7Pkbmq__innerPadding",
  "overviewbox": "Overviewbox-module-scss-module__7Pkbmq__overviewbox",
  "productLink": "Overviewbox-module-scss-module__7Pkbmq__productLink",
  "serviceDescription": "Overviewbox-module-scss-module__7Pkbmq__serviceDescription",
  "subtitle": "Overviewbox-module-scss-module__7Pkbmq__subtitle",
});
